<template>
    <div class="not-defined">
        <img src="@assets/images/404.png" />

        <div class="content">
            <h3 class="title">页面未找到</h3>
            <span>抱歉！您访问的页面不存在，请返回上一级或点击下方按钮返回首页...</span>
        </div>

        <div class="btn" @click="$router.replace({ path: '/' })">
            返回首页
        </div>
    </div>
</template>

<script>
export default {
    name: 'NotDefined'
};
</script>

<style scoped>
.not-defined img {
    width: 100%;
    margin-top: 10%;
}

.content {
    padding: 0 30px;
    text-align: center;
    color: #333;
    font-size: 24px;
}

.title {
    margin-bottom: 30px;
    color: #333;
    font-size: 28px;
}

.btn {
    color: #fff;
    background-color: #ef4c4c;
    font-size: 24px;
    padding: 20px 30px;
    border-radius: 40px;
    text-align: center;
    width: 200px;
    margin: 0 auto;
    margin-top: 60px;
}
</style>
